class TimeData {
    constructor({
        id = 0,
        stime = '00:00',
        etime = '00:00',
        errorText = '',
    } = {}) {
        this.id = id;
        this.stime = stime;
        this.etime = etime;
        this.errorText = errorText;
    }
}

export default TimeData;
